var React = require('react');

function TapHeadBgInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.743164","y":"0.799988","width":"510","height":"490","fill":"#E586AC"}));
}

TapHeadBgInline.defaultProps = {"width":"511","height":"491","viewBox":"0 0 511 491","fill":"none"};

module.exports = TapHeadBgInline;

TapHeadBgInline.default = TapHeadBgInline;
